// Styles
import './ScrollList.scss';

// Libs
import React, { useCallback, useMemo, useRef, useState } from 'react';

// Constants
import {
  ScrollListDefaultProps,
  ScrollListPropTypes,
} from './ScrollList.proptypes';

const ScrollList = ({ children, className, direction, scrollbar, speed }) => {
  const slider = useRef(null);

  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  /**
   * Generate classNames
   * @type {string}
   */
  const classNames = useMemo(
    () =>
      [
        'scroll-list',
        direction ? `scroll-list--${direction}` : null,
        !scrollbar ? 'scroll-list--no-scrollbar' : null,
        className,
      ]
        .filter((val) => val)
        .join(' '),
    [className, direction, scrollbar],
  );

  const handleMouseDown = useCallback((e) => {
    setIsDown(true);
    setStartX(e.pageX - slider.current.offsetLeft);
    setScrollLeft(slider.current.scrollLeft);

    slider.current.classList.add('scroll-list--grabbing');
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsDown(false);

    slider.current.classList.remove('scroll-list--grabbing');
  }, []);

  const handleMouseMove = useCallback(
    (e) => {
      if (!isDown) return;

      e.preventDefault();

      const x = e.pageX - slider.current.offsetLeft;
      const walk = (x - startX) * speed;

      slider.current.scrollLeft = scrollLeft - walk;
    },
    [isDown, scrollLeft, speed, startX],
  );

  const handleMouseUp = useCallback(() => {
    setIsDown(false);

    slider.current.classList.remove('scroll-list--grabbing');
  }, []);

  return (
    <ul
      className={classNames}
      data-qa-id="scroll-list"
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      ref={slider}
      role="listbox"
    >
      {children}
    </ul>
  );
};

ScrollList.defaultProps = {
  ...ScrollListDefaultProps,
};

ScrollList.propTypes = {
  ...ScrollListPropTypes,
};

export default ScrollList;
